import { PayloadAction, createSlice } from "@reduxjs/toolkit";

// ============ INTERFACE ============

export interface FlowStateInterface {
  flowType: 'web' | 'agent';
  /** True when the user entered through the active insurance comparison funnel. */
  isComparisonFunnel: boolean;
}

// ============ INIT STATE ============

const initialState: FlowStateInterface = {
  flowType: 'agent',
  isComparisonFunnel: false
};

// ========= SLICE ==========

export const flowSlice = createSlice({
  name: 'flow',
  initialState,
  reducers: {
    setFlowType: (state: FlowStateInterface, action: PayloadAction<'web' | 'agent'>) => {
      state.flowType = action.payload;
    },
    setIsComparisonFunnel: (state: FlowStateInterface, action: PayloadAction<boolean>) => {
      state.isComparisonFunnel = action.payload;
    },
  }
})

export const { setFlowType, setIsComparisonFunnel } = flowSlice.actions;

export default flowSlice.reducer;